
export const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCLgrwtY8tiYttfP6LH26yUe9Cu
aV5r0XXURBTiTz5oN5UWYKMs+Kf3SDhrDiCwBZpx6CuhbXsO14DBw8Waw43cta6n
ZnOOPzzFWAKeC2ffwY8mIE8VQ7rMAOjGrEtHMC698SGqBhSU6IsJyuoCLxrdfsuT
5Akz5bNacbl0I2ebewIDAQAB
-----END PUBLIC KEY-----`;